var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ChatPremium = function ChatPremium(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.814 4.186a.636.636 0 0 0-.45-.186H4.636A.636.636 0 0 0 4 4.636v13.58l3.388-2.07A1 1 0 0 1 7.909 16h11.455a.636.636 0 0 0 .636-.636V4.636a.636.636 0 0 0-.186-.45ZM19.364 2A2.636 2.636 0 0 1 22 4.636v10.728A2.636 2.636 0 0 1 19.364 18H8.19l-4.669 2.853A1 1 0 0 1 2 20V4.636A2.636 2.636 0 0 1 4.636 2h14.728Zm-5.325 11.952a.384.384 0 0 0 .421-.033.433.433 0 0 0 .159-.413l-.389-2.375 1.648-1.682c.11-.112.15-.28.103-.433a.406.406 0 0 0-.324-.288l-2.28-.35-1.019-2.163c-.135-.287-.581-.287-.716 0l-1.02 2.164-2.28.35a.406.406 0 0 0-.323.287.439.439 0 0 0 .103.433l1.648 1.682-.389 2.375a.432.432 0 0 0 .159.413.383.383 0 0 0 .42.033L12 12.828l2.04 1.124Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ChatPremium;